<template>
  <div class="contain">
    <!-- 第一部分 -->
    <div class="searchbox" style="padding-left: 30px">
      <el-row :gutter="20">
        <el-form :inline="true" :model="searchInput">
          <el-form-item>
            <el-input v-model="searchInput.createorName" placeholder="请输入工程师"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchInput.projectName" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 20px" @click="search('')">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
    <!-- 第二部分 -->
    <div class="colorBox">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="one colorSon" @click="search('')">
            <p class="p1">全部</p>
            <p class="p2">{{ allCount }}</p>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="two colorSon" @click="search('yesterDay')">
            <p class="p1">已提交</p>
            <p class="p2">{{ yesCount }}</p>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="three colorSon" @click="noSubmit">
            <p class="p1">未提交</p>
            <p class="p2">{{ noCount }}</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 列表 -->
    <div class="tableBox">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="createDt" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="center">
        </el-table-column>
        <el-table-column prop="nodeName" label="节点名称" align="center">
        </el-table-column>
        <el-table-column prop="createorName" label="工程师" align="center">
        </el-table-column>
        <el-table-column prop="content" label="内容" align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.currPage" :page-sizes="[100, 10, 20, 30, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <!-- 未提交对话框 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="500px">
      <div class="noSubmitBox">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-table :data="noSubmitData" border>
            <el-table-column prop="phone" label="账户名"> </el-table-column>
            <el-table-column prop="name" label="姓名"> </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchInput: {
        createorName: "",
      },
      allCount: "",
      noCount: "",
      yesCount: "",
      tableData: [],
      // 分页查询
      total: 0,
      currentPage: 1,
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 100,
        //查询条件
        condition: {
          type: "",
        },
      },
      dialogVisible: false,
      noSubmitData: [],
    };
  },
  methods: {
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    //顶部搜索
    search(type) {
      this.queryInfo.condition.createorName = this.searchInput.createorName;
      this.queryInfo.condition.projectName = this.searchInput.projectName;
      this.queryInfo.condition.type = type;
      console.log(type, this.queryInfo);
      this.getListData();
    },
    // 获取列表
    getListData() {
      var that = this;
      that.queryInfo.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      that.$http
        .post("/projectNodesLog/list", that.queryInfo)
        .then(function (response) {
          console.log("列表===>", response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            for (let i = 0; i < response.data.data.data.length; i++) {
              that.tableData[i].createDt = that.timeFormate(
                response.data.data.data[i].createDt
              );
            }
          }
        });
    },
    // 获取分类的数量
    getHeadernum() {
      var that = this;
      that.queryInfo.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      that.$http
        .post("/projectNodesLog/queryHeaderData", that.queryInfo)
        .then(function (response) {
          console.log("头部列表===>", response.data.data);
          if (response.data.code == 200) {
            that.allCount = response.data.data.allCount;
            that.noCount = response.data.data.noCount;
            that.yesCount = response.data.data.yesCount;
            that.noSubmitData = response.data.data.userInfos;
          }
        });
    },
    // 时间格式化
    timeFormate(originVal) {
      const dt = new Date(originVal);

      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");

      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      // yyyy-mm-dd hh:mm:ss
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
    noSubmit() {
      this.dialogVisible = true;
    },
  },
  created() {
    this.getListData();
    this.getHeadernum();
    var that = this;
    document.onkeydown = function (e) {   //按下回车提交
      let key = window.event.keyCode;
      //事件中keycode=13为回车事件
      if (key == 13) {
        that.getListData();
      }
    };
  },
};
</script>

<style lang="less" scoped>
.colorBox {
  padding-left: 20px;

  .colorSon {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100px;
    border-radius: 10px;
    color: #fff;

    .p1 {
      font-size: 18px;
    }

    .p2 {
      font-size: 36px;
    }
  }

  .one {
    background-color: #00b5f9;
  }

  .two {
    background-color: #f8ba74;
  }

  .three {
    background-color: #ff6d6d;
  }
}

.noSubmitBox {
  height: 300px;
  padding: 20px;
  box-sizing: border-box;
}

.tableBox {
  height: 600px;
  overflow-y: scroll;
}
</style>